import React from 'react';
import { useCheckout } from './CheckoutContext';
export function FinalCTA() {
  const {
    openUpsell,
    warmConnection
  } = useCheckout();
  return <section className="px-4 py-9 sm:py-12 border-t border-brand-gold/10" data-id="element-114">
      <div className="max-w-4xl mx-auto text-center" data-id="element-115">
        <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-5 sm:mb-6 leading-[1.1]" data-id="element-116">
          Dentro de 6 meses vas a estar en el mismo lugar...{' '}
          <span className="text-brand-gold" data-id="element-117">
            o vas a agradecer haber empezado hoy.
          </span>
        </h2>

        <div className="border border-brand-gold bg-dark-card rounded-lg p-5 sm:p-6" data-id="element-118">
          <div className="mb-4" data-id="element-119">
            <p className="text-brand-gray line-through text-sm sm:text-base mb-0" data-id="element-120">
              $50.000 ARS
            </p>
            <p className="text-brand-gold text-3xl sm:text-4xl font-bold leading-tight" data-id="element-121">
              $19.990 ARS
            </p>
          </div>

          <div className="grid grid-cols-2 gap-x-4 gap-y-1.5 max-w-md mx-auto mb-5" data-id="element-122">
            {['Acceso inmediato', 'Bonos incluidos', 'Garantía 7 días', 'Producto digital'].map((item, i) => <div key={i} className="flex items-center gap-2 text-xs sm:text-sm" data-id="element-123">
                <span className="text-brand-gold" data-id="element-124">✓</span>
                <span data-id="element-125">{item}</span>
              </div>)}
          </div>

          <button onClick={openUpsell} onMouseEnter={warmConnection} onTouchStart={warmConnection} className="w-full bg-brand-gold text-brand-black px-8 py-4 sm:py-5 rounded text-base sm:text-xl font-bold hover:opacity-90 transition-all hover:scale-[1.02]" data-id="element-126">
            QUIERO TRANSFORMAR MI REALIDAD
          </button>
        </div>
      </div>
    </section>;
}